import IGameAPI from "./IGameAPI";

export default class MockAPI implements IGameAPI {

    private seeds: number[];
    private firstSeed: number;

    constructor() {
        // 
    }

    public async getId(username: string): Promise<string> {

        return "local-id";
    }

    public async checkFreePass(username: string): Promise<any> {

        return false;
    }

    // HASTA QUE NO SE HA OBTENIDO EL PRIMER SEED EL JUEGO NO PUEDE EMPEZAR
    // UNTIL THE FIRST SEED HAS BEEN OBTAINED THE GAME CANNOT START
    public async fetchFirstSeed(id: string): Promise <number> {

        this.seeds = [ Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random()), Math.floor(1000 * Math.random())];
        
        this.firstSeed = this.seeds.pop();

        const self = this;

        return new Promise(function(resolve, reject) {
            setTimeout(resolve, 1000); 
        }).then(function() {
            return self.firstSeed;
        });
    }

    public async fetchFirstSeedDuel(id: string, duelId: number): Promise <number> {
        
        return null;
    }

    public async getCurrentPot(): Promise <any> {

       return null;
    }

    public fetchSeed(id: string, callback: Function, scope: any): void {
        
        const seed = this.seeds.pop() || Math.floor(1000 * Math.random());

        setTimeout(function(): void {
            callback.apply(scope, [seed]);
        }, 3000);
    }

    public async addActions(id: string, actions: Candy.Action[]): Promise <any> {
        
        return null;
    }

    public async onGameOver(id: string, startDate: Date, username: string, score: number): Promise <any> {

        return null;
    }

    public async getLeaderboardInfo(username: string): Promise <any> {

       return null;
    }

    public async getInitialDate(): Promise <Date> {

       return null;
    }

    public async proceedWithPayment(wax: any, startDate: Date, type: string): Promise <any> {

        return {type: "result", value: true};
    }

    public async proceedWithFreeTicket(wax: any, owner: string, id: number, startDate: Date): Promise <any> {

        return {type: "result", value: true};
    }

    public async updateRewards(startDate: Date): Promise<void> {
        // 
    }

    public async startReplay(username: string, game: string, date: string): Promise<any> {
        //
    }

    public async startReplayDuel(duel: number, player: number): Promise<any> {
        //
    }

    public async getDuel(username: string): Promise<any> {

        return {id: -1};
    }

    public async getDuelInfo(id: number): Promise<any> {

        return null;
    }

    public async onDuelEnd(duelID: number, seedsID: string, username: string, score: number, duration: number): Promise<any> {

        return null;
    }

    public async claimDuel(wax: any, id: number, username: string): Promise <any> {

        return null;
    }

    public historyDuel(id: number, username: string): void {
        // 
    }
}
